import React, { Suspense, lazy } from 'react';
import { HeroSection } from '../components/HeroSection';
import { StickyCTA } from '../components/StickyCTA';
const TrustBar = lazy(() => import('../components/TrustBar').then(m => ({
  default: m.TrustBar
})));
const ContrastSection = lazy(() => import('../components/ContrastSection').then(m => ({
  default: m.ContrastSection
})));
const ForWhomSection = lazy(() => import('../components/ForWhomSection').then(m => ({
  default: m.ForWhomSection
})));
const BenefitsSection = lazy(() => import('../components/BenefitsSection').then(m => ({
  default: m.BenefitsSection
})));
const ContentPreview = lazy(() => import('../components/ContentPreview').then(m => ({
  default: m.ContentPreview
})));
const BonusSection = lazy(() => import('../components/BonusSection').then(m => ({
  default: m.BonusSection
})));
const PricingSection = lazy(() => import('../components/PricingSection').then(m => ({
  default: m.PricingSection
})));
const GuaranteeSection = lazy(() => import('../components/GuaranteeSection').then(m => ({
  default: m.GuaranteeSection
})));
const TestimonialsSection = lazy(() => import('../components/TestimonialsSection').then(m => ({
  default: m.TestimonialsSection
})));
const ExpertSection = lazy(() => import('../components/ExpertSection').then(m => ({
  default: m.ExpertSection
})));
const FAQSection = lazy(() => import('../components/FAQSection').then(m => ({
  default: m.FAQSection
})));
const Footer = lazy(() => import('../components/Footer').then(m => ({
  default: m.Footer
})));
const SocialProofPopup = lazy(() => import('../components/SocialProofPopup').then(m => ({
  default: m.SocialProofPopup
})));
export function LandingPage() {
  return <main className="w-full min-h-screen bg-bg-main font-inter selection:bg-primary/30" data-id="element-294">
      <div data-id="element-295">
        <HeroSection data-id="element-296" />

        <Suspense fallback={null} data-id="element-297">
          <TrustBar data-id="element-298" />
          <ContrastSection data-id="element-299" />
          <ForWhomSection data-id="element-300" />
          <BenefitsSection data-id="element-301" />
          <ContentPreview data-id="element-302" />
          <BonusSection data-id="element-303" />
          <PricingSection data-id="element-304" />
        </Suspense>

        <Suspense fallback={null} data-id="element-305">
          <GuaranteeSection data-id="element-306" />
          <TestimonialsSection data-id="element-307" />
          <ExpertSection data-id="element-308" />
          <FAQSection data-id="element-309" />
          <Footer data-id="element-310" />
          <SocialProofPopup data-id="element-311" />
          <StickyCTA data-id="element-312" />
        </Suspense>
      </div>
    </main>;
}